import { createTheme } from '@mui/material/styles';
import { fontFamily, radius } from './tokens';

/**
 * Tema do MUI.
 *
 * **A paleta usa cores literais, não CSS custom properties.** O `createTheme`
 * precisa de uma cor real para derivar `light`, `dark` e `contrastText`, e
 * quebra em runtime com `var(--…)` ("MUI: Unsupported `var(...)` color").
 *
 * Por isso a divisão é:
 *
 * - **tema** → o que o MUI precisa resolver na criação: tipografia, raios,
 *   defaults de componente e uma paleta de fallback;
 * - **`src/theme/tokens.ts`** → o que os componentes consomem via `sx`, sempre
 *   como `var(--token, fallback)`. É por aí que a cor da marca, escrita em
 *   runtime pelo `BrandProvider`, chega à interface.
 *
 * Na prática: nenhum componente deve tirar cor de marca do `theme.palette`.
 * Use `colors` de `tokens.ts`.
 */

/** Verde Recarga Fácil — fallback quando nenhuma marca foi resolvida. */
const FALLBACK_PRIMARY = '#02EA75';
const FALLBACK_PRIMARY_DARK = '#02C864';

export const theme = createTheme({
  palette: {
    primary: { main: FALLBACK_PRIMARY, dark: FALLBACK_PRIMARY_DARK, contrastText: '#FFFFFF' },
    background: { default: '#F9FAFB', paper: '#FFFFFF' },
    text: { primary: '#111827', secondary: '#6B7280' },
    success: { main: '#16A34A' },
    error: { main: '#DC2626' },
    warning: { main: '#F59E0B' },
  },
  typography: {
    fontFamily,
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: radius.sm },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: radius.lg },
      },
    },
  },
});

export * from './tokens';
